"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var ListWrapper = _styledComponents.default.div.withConfig({
  displayName: "List__ListWrapper",
  componentId: "sc-xx0xo8-0"
})(["display:flex;flex-flow:column nowrap;width:100%;"]);
var List = function List(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ListWrapper, {
    children: children
  });
};
List.defaultProps = {
  width: '100%'
};
var _default = exports.default = List;